import { Typography } from "@mui/material";
import STRINGS from "../utils/strings";

export default function MetricInfo({ item }) {
  const colorsList = STRINGS.colors;
  const arrowsList = STRINGS.arrows;
  const color = item.colorState;
  const arrow = item.arrowState;

  return (
    <div
      className={`border rounded-md flex flex-row items-center justify-start w-[45%] h-[100px] px-6 py-4 m-4 ml-0 gap-2 shadow-md`}
      style={{
        backgroundColor: colorsList[color].backgroundColor,
        borderColor: colorsList[color].borderColor,
      }}
    >
      <Typography className="font-thin text-4xl text-black">
        {item.value}
      </Typography>
      <div className="flex flex-row items-center">
        <Typography
          className={`font-semibold text-xl pl-4`}
          style={{
            color: colorsList[color].textColor,
            borderColor: colorsList[color].borderColor,
          }}
        >
          {item.header}
        </Typography>
        {
          <span
            style={{
              color: colorsList[color].arrowTextColor,
            }}
          >
            {arrowsList[arrow]}
          </span>
        }
      </div>
    </div>
  );
}
